import { render } from "./TurnCharacter.vue?vue&type=template&id=8630462a&scoped=true"
import script from "./TurnCharacter.vue?vue&type=script&lang=js"
export * from "./TurnCharacter.vue?vue&type=script&lang=js"

import "./TurnCharacter.vue?vue&type=style&index=0&id=8630462a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8630462a"]])

export default __exports__